import { createFileRoute } from "@tanstack/react-router";
import {
  CustomIndustryServicePage,
  buildCustomIndustryServiceHead,
} from "@/components/CustomIndustryServicePage";
import { getCustomEntry } from "@/lib/customIndustryServiceData";

const ENTRY = getCustomEntry("seo-for-roofing")!;

export const Route = createFileRoute("/seo-for-roofing")({
  head: () => buildCustomIndustryServiceHead(ENTRY),
  component: () => <CustomIndustryServicePage entry={ENTRY} />,
});
